'use client';
import { useTranslation } from '@/i18n/LanguageProvider';
import Link from '@/components/LocaleLink';

export default function CookiesPage() {
  const { t } = useTranslation();
  return (
    <div>
      <section className="bg-gradient-to-br from-primary-600 to-secondary-600 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-4">{t('cookies.title')}</h1>
          <p className="text-white/80">{t('cookies.lastUpdated')}: {t('cookies.date')}</p>
        </div>
      </section>
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg prose-gray max-w-none">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-8 mb-4">{t('cookies.s1Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('cookies.s1Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('cookies.s2Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('cookies.s2Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('cookies.s3Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('cookies.s3Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('cookies.s4Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('cookies.s4Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('cookies.s5Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('cookies.s5Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('cookies.s6Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('cookies.s6Text')}</p>
          <div className="mt-8 text-center">
            <Link href="/privacy" className="text-primary hover:underline font-semibold">{t('privacy.title')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
